module.exports = {"id":"154634","name":"Manuel Pasqual","rating":"73","photo":"./data/images/photos/0/154634.png","club":{"name":"Empoli","logo":"./data/images/clubs/Empoli.png"},"positions":["DG","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ManuelPasqual0.json
// module id = 2687
// module chunks = 0